import HelpCenters from './src/main'

HelpCenters.install = function(Vue) {
  Vue.component(HelpCenters.name, HelpCenters)
}

export default HelpCenters